var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7249 2.424L21.7249 2.42402C23.8993 4.77296 24.132 8.59096 22.1108 10.9029C19.9726 13.3484 13.5225 19.073 11.9716 20.4408C10.427 19.0672 4.00448 13.32 1.87585 10.8678C-0.137791 8.54811 0.108843 4.73091 2.29128 2.39071C4.45711 0.0683081 7.93283 -0.156241 10.107 1.95039C10.3811 2.21605 11.0283 2.91825 11.3916 3.31559L11.3918 3.31576C11.7222 3.67685 12.2837 3.67837 12.6157 3.31791L12.6157 3.3179C12.9814 2.92089 13.6343 2.21789 13.9107 1.95205C16.092 -0.145485 19.567 0.0926767 21.7249 2.424Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyHeart);
export default __webpack_public_path__ + "static/media/empty_heart.7243284a0340c210ee57709a29b4cf8a.svg";
export { ForwardRef as ReactComponent };